import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["impact"]

  connect() {
    this.refresh()
    this.observer = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches('[data-fuel-sample], .correction-row') || node.querySelector('[data-fuel-sample], .correction-row'))))) this.refresh()
    })
    this.observer.observe(this.element, {childList: true, subtree: true})
  }

  disconnect() { this.observer?.disconnect() }

  refresh() {
    const samples = [...this.element.querySelectorAll('[data-fuel-sample]')].filter(row => row.querySelector('[data-fuel-destroy]').value !== '1').map(row => ({
      key: row.querySelector('[data-fuel-key]').value,
      name: row.querySelector('[data-fuel-name]').value,
      density: row.querySelector('[data-fuel-density]').value,
      temperature: row.querySelector('[data-fuel-temperature]').value,
      source: row.querySelector('[data-fuel-source]').value
    }))
    let netChange = 0, linked = 0, invalid = 0
    this.element.querySelectorAll('.correction-row').forEach(row => {
      const mode = row.querySelector('[data-fuel-mode]')
      if (!mode || row.querySelector('[data-nested-remove-target="destroyField"]')?.value === '1') return
      const volumeMode = mode.value === 'volume'
      const select = row.querySelector('[data-fuel-sample-select]')
      const previousKey = select.value
      const blankLabel = select.options[0]?.textContent || 'Select a sample'
      select.replaceChildren(new Option(blankLabel, ''), ...samples.map(sample => new Option(sample.name || 'Unnamed sample', sample.key)))
      if (previousKey && !samples.some(sample => sample.key === previousKey)) select.add(new Option('Sample removed — choose another', previousKey))
      select.value = previousKey
      row.querySelectorAll('[data-fuel-volume-field]').forEach(field => {
        field.hidden = !volumeMode
        field.querySelectorAll('input, select').forEach(input => { input.disabled = !volumeMode })
      })
      const weight = row.querySelector('[data-auto-moment-target="weight"]')
      const preview = row.querySelector('[data-fuel-preview]')
      weight.readOnly = volumeMode
      preview.textContent = ''
      if (!volumeMode) return
      const sample = samples.find(sample => sample.key === select.value)
      const density = Number(sample?.density ?? (!select.value ? select.dataset.legacyDensity : NaN))
      const volume = Number(row.querySelector('[data-fuel-volume]').value)
      const complete = !sample || (sample.name.trim() !== '' && sample.temperature !== '' && Number.isFinite(Number(sample.temperature)) && Math.abs(Number(sample.temperature)) <= 100 && sample.source.trim() !== '')
      const valid = complete && Number.isFinite(density) && density > 0 && density <= 1 && Number.isFinite(volume) && volume > 0
      weight.value = valid ? (volume * density).toFixed(2) : ''
      weight.dispatchEvent(new Event('input'))
      if (valid) {
        preview.textContent = `${volume} L × ${density} kg/L = ${weight.value} kg${sample ? ` · ${sample.name} at ${sample.temperature}°C` : ' · preserved measurement'}`
        const direction = row.querySelector('[data-auto-moment-target="type"]').value === 'subtraction' ? -1 : 1
        netChange += direction * (Number(weight.value) - Number(preview.dataset.originalWeight || 0))
      } else {
        invalid++
        preview.textContent = 'Enter a volume and select a complete fuel sample in Setup.'
      }
      linked++
    })
    if (this.hasImpactTarget) this.impactTarget.textContent = linked ? `${linked} volume-based fuel correction${linked === 1 ? '' : 's'} · ${invalid ? `${invalid} incomplete` : `net mass change from saved draft: ${netChange >= 0 ? '+' : ''}${netChange.toFixed(2)} kg`}. Save to apply.` : 'No volume-based fuel corrections linked yet.'
    this.element.dispatchEvent(new Event('fuel-samples:updated', {bubbles: true}))
  }
}
